import { render, staticRenderFns } from "./crudPagesBlocksContents.vue?vue&type=template&id=8869a960&"
import script from "./crudPagesBlocksContents.vue?vue&type=script&lang=js&"
export * from "./crudPagesBlocksContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports